import { render } from "./TextareaAutosize.vue?vue&type=template&id=f90120de&scoped=true"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js"

import "./TextareaAutosize.vue?vue&type=style&index=0&id=f90120de&scoped=true&lang=css"

import exportComponent from "/Users/macmeow/Documents/GitHub/feedback-page-partnership/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f90120de"]])

export default __exports__